import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=76628650&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76628650",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76628650')) {
      api.createRecord('76628650', component.options)
    } else {
      api.reload('76628650', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=76628650&scoped=true&", function () {
      api.rerender('76628650', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2yKOn6QKw6xUf/JS/comp/Accordion.vue"
export default component.exports